import { createFeatureSelector, createSelector } from '@ngrx/store';

import { TAGS_REDUCER_KEY } from '../reducers/tags.reducer';
import { getCurrentOrganizationId$ } from './session.selector';

import type { TagsState } from '../states';
const currentState = createFeatureSelector<TagsState>(TAGS_REDUCER_KEY);

export const getTagsOrganizationMap$ = createSelector(
    currentState,
    getCurrentOrganizationId$,
    (state, organizationId) => state.organizationsMap?.[organizationId]
);

export const getTagsObject$ = createSelector(getTagsOrganizationMap$, orgMap => orgMap?.tagKeyValuesVsAppDetails);

export const getTagValueVsServiceIds$ = (key: string, value: string, status?: string, array?: boolean) =>
    createSelector(getTagsOrganizationMap$, orgMap => {
        if (array) {
            return (orgMap?.tagKeyValuesVsAppDetails?.[`${key}|${value}|${status || 'APPROVED'}`] || []).reduce((values, data) => {
                values.push(data?.serviceId);
                return values;
            }, []);
        }
        return (orgMap?.tagKeyValuesVsAppDetails?.[`${key}|${value}|${status || 'APPROVED'}`] || []).reduce(
            (tagValueMap, data) => {
                tagValueMap[data.tagValue] = data?.serviceId;
                return tagValueMap;
            },
            {} as {
                [property: string]: string;
            }
        );
    });

export const getAssetsTags$ = createSelector(getTagsOrganizationMap$, orgMap => orgMap?.serviceIdVsTags);

export const getAssetTags$ = (serviceId: string) => createSelector(getAssetsTags$, serviceIdsMap => serviceIdsMap?.[serviceId]);
